import _get from 'lodash/get';
import { useFormikContext } from 'formik';

import React, { useState } from 'react';
import { MdInsertLink } from 'react-icons/md';
import Error from './Error';
import classNames from 'classnames';
import TextareaAutosize from './TextareaAutoSize';
import LinkForm from 'legacy/events/components/create-event/settings/LinkForm';

const FIELD_NAME = 'description';

const Description = () => {
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const toggleModal = () => {
    setIsLinkModalOpen(!isLinkModalOpen);
  };

  const { errors, values, touched, setFieldValue } = useFormikContext<any>();

  const showError = !!_get(errors, FIELD_NAME) && !!_get(touched, FIELD_NAME);

  const handleLinkFormSubmit = ({ text, link }) => {
    setFieldValue('description', `${values.description}\n[${text}](${link})`);

    toggleModal();
  };

  return (
    <>
      <div className="pt-7 text-base text-gray-800 font-semibold">
        About the event *
      </div>

      <div
        className={classNames('text-base placeholder:text-gray-500 w-full', {
          'bg-red-100 rounded-md px-1': showError
        })}
      >
        <TextareaAutosize
          className="w-full bg-transparent py-4"
          id="description"
          name="description"
          placeholder="Tell us more about your event..."
        />
      </div>

      {showError && <Error error={_get(errors, FIELD_NAME)} />}

      <button
        type="button"
        className="mt-4 text-primary-500 font-semibold text-base flex items-center"
        onClick={toggleModal}
      >
        <MdInsertLink size={24} className="mr-1" /> Add hyperlink
      </button>

      {isLinkModalOpen && (
        <LinkForm
          onClose={toggleModal}
          onSubmit={handleLinkFormSubmit}
          title="Add hyperlink"
        />
      )}
    </>
  );
};

export default Description;
